const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  phone: state => state.user.phone,
  icon: state => state.user.icon
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js